import { render, staticRenderFns } from "./InvestmentMix.vue?vue&type=template&id=4d59655f&"
import script from "./InvestmentMix.vue?vue&type=script&lang=js&"
export * from "./InvestmentMix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports